// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"8":"badec104","125":"ee8346bf","135":"badec104","174":"1194ffc8","228":"437b83fd","856":"ab61be89"}[chunkId] + ".css";
};